export default __webpack_public_path__ + "static/media/GW-4000+.c220e3fa.png";